import * as React from 'react';
import { cn } from '@ui/lib/utils';

export type SkeletonProps = {
  className?: string;
  /** Use `span` when placed inside a heading to keep valid phrasing content (e.g. Dialog title). */
  as?: 'div' | 'span';
} & (React.ComponentProps<'div'> | React.ComponentProps<'span'>);

const baseClass = 'animate-pulse rounded-md bg-muted';

function Skeleton({ className, as, ...rest }: SkeletonProps) {
  if (as === 'span') {
    const p = rest as React.ComponentProps<'span'>;
    return <span data-slot="skeleton" className={cn(baseClass, className)} {...p} />;
  }
  const p = rest as React.ComponentProps<'div'>;
  return <div data-slot="skeleton" className={cn(baseClass, className)} {...p} />;
}

export { Skeleton };
